import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ClassicEditor from 'classic-editor';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { MATH_SCRIPT_URL, WARNING_LOADING_ADDON } from '../../utils/constants';
import { Wrapper } from './wrapper';
import { loadMathScript } from '../../utils/loadMathScript';
// TODO: Remove after testing
import CKEditorInspector from '@ckeditor/ckeditor5-inspector';
const Editor = ({
  onChange,
  name,
  value,
  config,
  disabled = false,
  onLoad
}) => {
  const [isEditorVisible, setIsEditorVisible] = useState(false);
  useEffect(() => {
    loadMathScript(setIsEditorVisible);
  }, []);
  return /*#__PURE__*/React.createElement(Wrapper, null, isEditorVisible && /*#__PURE__*/React.createElement(CKEditor, {
    editor: ClassicEditor,
    data: value,
    disabled: disabled,
    onChange: (event, editor) => {
      const data = editor.getData();
      onChange(editor, {
        target: {
          name,
          value: data
        }
      });
    },
    onNamespaceLoaded: CKEDITOR => {
      const scripts = [];
      scripts.push(MATH_SCRIPT_URL);
      CKEDITOR.scriptLoader.load(scripts, (completed, failed) => {
        if (failed.length > 0) {
          strapi.notification.toggle(WARNING_LOADING_ADDON);
        }
      });
    },
    config: config,
    onReady: editor => {
      // TODO: Remove after testing
      //CKEditorInspector.attach(editor);
      onLoad(editor);
    }
  }));
};
Editor.propTypes = {
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string
};
export default Editor;